import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-cobranza',
  templateUrl: './dashboard-cobranza.component.html',
  styleUrls: ['./dashboard-cobranza.component.scss']
})
export class DashboardCobranzaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
